import moment from 'moment';

import {
  genIasDeviceFiltersList,
  genIasMediaFormatFiltersList,
  getIasFilterOptionsList,
  IasFilter,
} from '~/src/dash/api/ias-filter';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IMenuList } from '~/src/dash/types/menuList';

interface IIasReportFilter {
  key: string;
  apiKey: string;
  getList?: (
    session: ISessionState,
    dimension: string,
    startDate: moment.Moment,
    endDate: moment.Moment,
  ) => Promise<Record<string, IMenuList>>;
  list?: IasFilter[];
}

export const IAS_REPORT_FILTERS: IIasReportFilter[] = [
  {
    key: 'advertiser',
    apiKey: 'Advertiser',
    getList: (
      session: ISessionState,
      dimension: string,
      startDate: moment.Moment,
      endDate: moment.Moment,
    ) => getIasFilterOptionsList(session, dimension, startDate, endDate),
  },
  {
    key: 'adUnit',
    apiKey: 'AdUnit',
    getList: (
      session: ISessionState,
      dimension: string,
      startDate: moment.Moment,
      endDate: moment.Moment,
    ) => getIasFilterOptionsList(session, dimension, startDate, endDate),
  },
  {
    key: 'creative',
    apiKey: 'Creative',
    getList: (
      session: ISessionState,
      dimension: string,
      startDate: moment.Moment,
      endDate: moment.Moment,
    ) => getIasFilterOptionsList(session, dimension, startDate, endDate),
  },
  {
    key: 'deal',
    apiKey: 'DealID',
    getList: (
      session: ISessionState,
      dimension: string,
      startDate: moment.Moment,
      endDate: moment.Moment,
    ) => getIasFilterOptionsList(session, dimension, startDate, endDate),
  },
  { key: 'deviceType', apiKey: 'DeviceType', list: genIasDeviceFiltersList() },
  {
    key: 'lineItem',
    apiKey: 'LineItem',
    getList: (
      session: ISessionState,
      dimension: string,
      startDate: moment.Moment,
      endDate: moment.Moment,
    ) => getIasFilterOptionsList(session, dimension, startDate, endDate),
  },
  { key: 'mediaFormat', apiKey: 'MediaFormat', list: genIasMediaFormatFiltersList() },
  {
    key: 'order',
    apiKey: 'Order',
    getList: (
      session: ISessionState,
      dimension: string,
      startDate: moment.Moment,
      endDate: moment.Moment,
    ) => getIasFilterOptionsList(session, dimension, startDate, endDate),
  },
];
